/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:399a55df-33e5-4354-a9a1-202cc2bc1318",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_XqeS0C4Cm",
    "aws_user_pools_web_client_id": "7uut10qp3lerua3m1j4lji4rkc",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://ec75dsb225bm7g2nmelxtzf5by.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-jhcmlrt5nrekxobqn6ubi4zka4",
    "aws_user_files_s3_bucket": "aabportal-storage120524-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
